<template>
    <div class="container order-page">
        <div v-if="orderList.length != 0">
            <!-- begin 已点菜品 -->
            <v-layout justify-center column>
                <v-flex class="your-order-container" xs6>
                    <div
                        v-for="(orderItem, index) in orderList"
                        class="order-table"
                        :key="orderItem && orderItem.id || index"
                    >
                        <div class="add-product">
                            {{ index == 0 ? $t("ordered.first") : $t("checkout.extra") }}
                        </div>
                        <table class="order-table">
                            <tr
                                class="order-item"
                                v-for="(item, index) in orderItem"
                                :key="index"
                            >
                                <div class="order-item-content">
                                    <td>
                                        <div>
                                            {{
                                                (item.commodity && item.commodity.commodity_name_json &&
                                                    item.commodity.commodity_name_json[getTranslateIndex]) ||
                                                item.upName || item.name
                                            }}
                                        </div>
                                        <div class="attributes">
                                            <span v-for="attr in item.attributes" :key="attr.guid" style="padding-right: 6px; white-space: nowrap;">
                                                {{ attr.name }} <span v-if="attr.price && Number(attr.price)">€{{ attr.price }}</span>
                                            </span>
                                        </div>
                                    </td>

                                    <td class="price">
                                        <strong class="num">X{{ item.quantity }}</strong>
                                    </td>
                                    <td class="price">
                                        <!-- 价格 -->
                                        <div class="unit-price" style="white-space: nowrap;">€ {{ item.totalPrice || item.total }}</div>
                                    </td>
                                </div>
                                <div>
                                    <div
                                        class="garnish"
                                        v-for="(item, index) in item.garnish"
                                        :key="index"
                                    >
                                        <span>
                                            {{
                                                (item.commodity && item.commodity.commodity_name_json &&
                                                    item.commodity.commodity_name_json[getTranslateIndex]) ||
                                                item.upName || item.commodity_name
                                            }}
                                        </span>
                                        <span>€ {{ item.commodity_price }}</span>
                                    </div>
                                </div>
                            </tr>
                        </table>
                    </div>
                </v-flex>
            </v-layout>
            <!-- end 已点菜品 -->

            <!-- begin 小计 -->
            <div class="total-container">
                <div>{{ $t("checkout.subtotal") }}</div>
                <strong class="total-price">{{ myOrder.actuallyPaidAmount }} €</strong>
            </div>
            <!-- end 小计 -->
        </div>

        <div v-else class="none-container">
            <img src="../../../assets/icon-none.png"/>
            <div class="tip">{{ $t("ordered.none") }}</div>
        </div>

        <div class="bottom-btn" @click="backHome">
            {{ $t("ordered.back_home") }}
        </div>
    </div>
</template>
<script>
import {mapState, mapActions, mapGetters} from "vuex";
import {fixed} from "../../../utils";

export default {
    data: function () {
        return {};
    },

    computed: {
        ...mapState([
            "tableGuid",
            "myOrder",
            "storeId",
            "tableNum",
            "orderList",
            "pageFrom",
            "tokenContent",
            "lang"
        ]),
        ...mapGetters(["getTranslateIndex"]),
    },

    created() {
        this.getMyOrder();
    },

    mounted() {
    },

    methods: {
        ...mapActions(["getMyOrder"]),

        backHome() {
            if (this.pageFrom == "store" && this.$route.query.redirect == "table" && false) {
                // 商家app 结算结束
                this.$router.push({
                    name: "table",
                    query: {
                        storeGuid: this.storeId,
                        from: this.pageFrom,
                        lang: this.lang,
                        token: this.tokenContent
                    }
                });
            } else {
                this.$router.push({
                    name: "delivery/list",
                    query: {
                        storeId: this.storeId,
                        tableGuid: this.tableGuid,
                        tableNum: this.tableNum
                    }
                });
            }
        }
    },
    filters: {
        fixed
    }
};
</script>

<style scoped lang="sass" src="./ordered.sass"></style>
